export enum CACHE_KEY {
  deepSavingsDetails = 'deepSavingsDetails',
  deepSavingsSource = 'deepSavingsSource',
}
